import Image from "next/image";
import React from "react";
import styles from "./upsc-sociology-optional.module.css";
import Link from "next/link";

import SHOBHIKA from "../../assets/images/upsc/Sociology-Toppers/AIR-35-SHOBHIKA-PATHAK.png";
import MALAVIKA from "../../assets/images/upsc/Sociology-Toppers/AIR-45-MALAVIKA- NAIR.png";
import NITISHA from "../../assets/images/upsc/Sociology-Toppers/AIR-133-Nitisha.png";
import RAJATH from "../../assets/images/upsc/Sociology-Toppers/AIR-169-RAJATH.jpg";
import ANUPRIYA from "../../assets/images/upsc/Sociology-Toppers/AIR-189-ANUPRIYA-RAI.jpg";
import HEMANTH from "../../assets/images/upsc/Sociology-Toppers/AIR-223-HEMANTH.jpg";
import AKSHAY from "../../assets/images/upsc/Sociology-Toppers/AIR-246-AKSHAY-DILEEP.jpg";
import LAKSHMIMENON from "../../assets/images/upsc/Sociology-Toppers/AIR-310-LAKSHMI-MENON.png";
import SUMEET from "../../assets/images/upsc/Sociology-Toppers/AIR-390-SUMEET.png";
import MICHAELJOM from "../../assets/images/upsc/Sociology-Toppers/AIR-415-MICHAELJOM.png";
import OORMI from "../../assets/images/upsc/Sociology-Toppers/AIR-563-OORMILA.png";
import SWAPNILBAGAL from "../../assets/images/upsc/Sociology-Toppers/AIR-620-SWAPNIL BAGAL.png";
import ARUNPRAKASH from "../../assets/images/upsc/Sociology-Toppers/AIR-639-ARUNPRAKASH.png";
import Donepudi from "../../assets/images/upsc/Sociology-Toppers/AIR-681-Donepudi-VijayBabu.png";
import AJAY from "../../assets/images/upsc/Sociology-Toppers/AIR-730-AJAY R RAJ.png";
import SARAVANAKUMAR from "../../assets/images/upsc/Sociology-Toppers/AIR-745-SARAVANAKUMAR.jpg";
import RAJDEEPGHOSH from "../../assets/images/upsc/Sociology-Toppers/AIR-789-RAJDEEPGHOSH.png";
import RIYAZ from "../../assets/images/upsc/Sociology-Toppers/AIR-791-RIYAZ-WATSON.png";
import MAYANK  from "../../assets/images/upsc/Sociology-Toppers/17.jpg";
import VISHALI from "../../assets/images/upsc/Sociology-Toppers/AIR-805-VISHALI.png"; 
import SAJEEV from "../../assets/images/upsc/Sociology-Toppers/AIR-838-SAJEEV.png";
import VIKAS from "../../assets/images/upsc/Sociology-Toppers/AIR-845-VIKAS MEENA.png";
import BHARADHWAJ from "../../assets/images/upsc/Sociology-Toppers/AIR-905-PARGI BHARADHWAJ.png";
import LAXMI from "../../assets/images/upsc/Sociology-Toppers/AIR-977-LAXMI.png";
import DHANYA from "../../assets/images/upsc/Sociology-Toppers/AIR-982-DHANYA.png";



import NANDALA from "../../assets/images/upsc/Sociology-Toppers/27-NANDALA.png";
import FABIRASHEED from "../../assets/images/upsc/Sociology-Toppers/71-FABI-RASHEED.png";
import MANOJKUMAR from "../../assets/images/upsc/Sociology-Toppers/120-MANOJ KUMAR.png";
import SYEDADEELMOHSIN from "../../assets/images/upsc/Sociology-Toppers/157-SYED ADEEL MOHSIN.png"; 
import ANURAGCHOPRA from "../../assets/images/upsc/Sociology-Toppers/210-ANURAG-CHOPRA.png";
import JAHNAVI from "../../assets/images/upsc/Sociology-Toppers/324-JAHNAVI.png";
import AREEBANOMAAN from "../../assets/images/upsc/Sociology-Toppers/339-AREEBA NOMAAN.png";  
import ARUNBALGOTRA from "../../assets/images/upsc/Sociology-Toppers/400-ARUN BALGOTRA.png";
import AKSHAYDILEEP from "../../assets/images/upsc/Sociology-Toppers/439-AKSHAY DILEEP.png";
import GOBBILLA from "../../assets/images/upsc/Sociology-Toppers/444-GOBBILLA KRISHNASREEVASTAV.png";
import LAKSHMI from "../../assets/images/upsc/Sociology-Toppers/477-LAKSHMI MENON V.png";
import HARSHVARDHAN from "../../assets/images/upsc/Sociology-Toppers/489-HARSHVARDHAN PANDEY.png";
import DEVIKRISHNAP from "../../assets/images/upsc/Sociology-Toppers/559-DEVIKRISHNA-P.png";
import OORMILA from "../../assets/images/upsc/Sociology-Toppers/561-OORMILA-J-S.png";
import LAXMANANAND from "../../assets/images/upsc/Sociology-Toppers/643-LAXMAN-ANAND.png";
import SHYAMALAT from "../../assets/images/upsc/Sociology-Toppers/695-SHYAMALA-T.png";
import SAYANTH from "../../assets/images/upsc/Sociology-Toppers/701-SAYANTH-K.png";
import SHRISHTIDEEP from "../../assets/images/upsc/Sociology-Toppers/748-SHRISHTI-DEEP.png";
import HAVISHC from "../../assets/images/upsc/Sociology-Toppers/792-HAVISH-C.png";
import RAGHUL from "../../assets/images/upsc/Sociology-Toppers/904-A RAGHUL.png";
import KAJALRAJU from "../../assets/images/upsc/Sociology-Toppers/956-KAJAL RAJU.png";
import GOVADANAVYA from "../../assets/images/upsc/Sociology-Toppers/995-GOVADA-NAVYA-SREE.png";



const UPSC_Main_Test_Series_2023 = () => {

    return (
        <>

          <div className="container pt-2 pt-lg-3 mb-4 mb-md-5">
            <div className="row" >
                 <div className="col col-md-6 pt-3 text-center">
                  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>Our Sociology Toppers 2024</h2>
                 </div>
                <div className="col col-md-6 pt-3 text-center">
                <Link href={"https://www.shankariasparliament.com/upsc-toppers-list/SC2024"} target={"_blank"} rel="preconnect" className={`${styles.viewbuttonalink}`}>
                  <button type="button" className={`${styles.viewbutton}`}>
                  Click here for toppers Answer sheet
                  </button>
                </Link>
              </div>
                 
                  <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SHOBHIKA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>SHOBHIKA PATHAK</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 37 (2024)</p> 
                        </div>
                </div>

                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={MALAVIKA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> MALAVIKA G NAIR</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 45 (2024)</p> 
                        </div>
                </div> 

                
                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={NITISHA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> NITISHA THAKWANI</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 133 (2024)</p>   
                        </div>
                </div>
                 
                 
                 
                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={RAJATH} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> RAJATH R</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 169 (2024)</p>   
                        </div>
                </div> 


                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={ANUPRIYA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> ANUPRIYA RAI</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 189 (2024)</p>   
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={HEMANTH} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> HEMANTH SANKAR P</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 223 (2024)</p>   
                        </div>
                </div> 

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={AKSHAY} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> AKSHAY DILEEP</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 246 (2024)</p>
                              
                        </div>
                </div> 

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={LAKSHMIMENON} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> LAKSHMI MENON V</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 310 (2024)</p>
                              
                        </div>
                </div>

                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SUMEET} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> SUMEET CHAKRAVARTY</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 390 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={MICHAELJOM} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> MICHAEL JOM</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 415 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={OORMI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> OORMILA J S</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 563 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SWAPNILBAGAL} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> SWAPNIL BAGAL</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 620 (2024)</p>
                              
                        </div>
                </div> 

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={ARUNPRAKASH} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> ARUNPRAKASH M</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 639 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={Donepudi} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> DONEPUDI VIJAY BABU</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 681 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={AJAY} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> AJAY R RAJ</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 730 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SARAVANAKUMAR} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> SARAVANA KUMAR T</p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 745 (2024)</p>
                              
                        </div>
                </div> 

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={RAJDEEPGHOSH} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> RAJDEEP GHOSH </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 789 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={RIYAZ} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> RIYAZ WATSON J </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 791 (2024)</p>
                              
                        </div>
                </div>

                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={MAYANK} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> MAYANK BHUSHAN SINGH </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 804 (2024)</p>
                              
                        </div>
                </div> 

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={VISHALI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> VISHALI P </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 805 (2024)</p>
                              
                        </div>
                </div>

                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={SAJEEV} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> SAJEEV P </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 838 (2024)</p>
                              
                        </div>
                </div>

                  <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={VIKAS} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}>  VIKAS MEENA </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 845 (2024)</p>
                              
                        </div>
                </div>

                 <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={BHARADHWAJ} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> PARGI BHARADHWAJ </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 905 (2024)</p>
                              
                        </div>
                </div>

                <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={LAXMI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> LAXMI </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 977 (2024)</p>
                              
                        </div>
                </div> 

                 {/* <div className="col-12  col-md-3 text-center py-xl-2 pt-3 pt-md-3">
                        <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                            <div className={`${ styles.toppersupsc}`}> 
                              <Image src={DHANYA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            </div>
                            <span1 className={`${ styles.medalicon}`}></span1>
                                <p className={`${styles.acheivername} text-center mb-0`}> DHANYA </p>
                                <p className={`${styles.acheiverrank} text-center mb-0`}>AIR - 982 (2024)</p>
                              
                        </div>
                </div> */}
            </div>
        </div>



        <div className="container pt-2 pt-lg-3 mb-4 mb-md-5">
            <div className="row" >
                <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>Our Sociology Toppers 2023</h2>
                <div className="col-12  col-md-3 text-center py-xl-2 pt-md-3">
                    <div className="h-100 pt-3 pb-3 " style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1' }}>
                        <Image src={NANDALA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            <p className={`${styles.acheivername} text-center mb-0`}> NANDALA SAIKIRAN</p>
                            <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 27(2023)</p>
                            <p className={`${styles.acheivername}  text-center mb-0 `}>Sociology Written Score - 283 </p>       
                    </div>
                </div>

                <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                    <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE 0% 0% no-repeat padding-box', opacity: '1'}} >
                        <Image src={FABIRASHEED} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                            <p className={`${styles.acheivername} text-center mb-0`}>FABI RASHEED</p>
                            <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR - 71(2023)</p>
                            <p className={`${styles.acheivername}  text-center mb-0 `}>Sociology Written Score - 281 </p>         
                    </div>
                </div>

                <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE 0% 0% no-repeat padding-box', opacity: '1'}}>
                           
                                        <Image src={MANOJKUMAR} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>MANOJ KUMAR</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 120(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Sociology Written Score - 242 </p>
                                       
                            </div>
                        </div>

                        

                       <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={SYEDADEELMOHSIN} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> SYED ADEEL MOHSIN</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 157(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Sociology Written Score - 269 </p>
                                       
                           
                            </div>
                        </div>

                         <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={ANURAGCHOPRA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>ANURAG CHOPRA</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 210(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Sociology Written Score - 273 </p>
                                       
                           
                            </div>
                        </div>

                       

                       <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={JAHNAVI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> JAHNAVI</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 324(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 285  </p>
                                      
                            </div>
                        </div>

                       <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={AREEBANOMAAN} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>AREEBA NOMAAN</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 339(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 252</p>
                                                               
                            </div>
                        </div>

                          <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={ARUNBALGOTRA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> ARUN BALGOTRA</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 400(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 226 </p>
                                   
                            </div>
                        </div>

                        
                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={AKSHAYDILEEP} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> AKSHAY DILEEP</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 439(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 234 </p>
                               
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={GOBBILLA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> GOBBILLA KRISHNASREEVASTAV</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 444(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 260</p>
                                                                
                            </div>
                        </div>

                          
                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={LAKSHMI} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>LAKSHMI MENON V</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 477(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 240</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={HARSHVARDHAN} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  HARSHVARDHAN PANDEY </p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 489(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 277</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={DEVIKRISHNAP} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  DEVIKRISHNA P</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 559(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 233</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={OORMILA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> OORMILA J S</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 561(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 244</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={LAXMANANAND} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  LAXMAN ANAND </p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 643(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 252</p>
                                      
                           
                            </div>
                        </div>


                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={SHYAMALAT} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> SHYAMALA T </p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 695(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 258</p>
                                      
                           
                            </div>
                        </div>


                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={SAYANTH} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  SAYANTH K</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 701(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 236</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={SHRISHTIDEEP} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}> SHRISHTI DEEP</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 748(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 249</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={HAVISHC} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  HAVISH C</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 792(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 237</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={RAGHUL} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  A RAGHUL</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 904(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 230</p>
                                      
                           
                            </div>
                        </div>


                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={KAJALRAJU} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  KAJAL RAJU</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 956(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 225</p>
                                      
                           
                            </div>
                        </div>


                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                            <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                            <Image src={GOVADANAVYA} className="img-fluid" alt="Upsc_toppers" title="Upsc_toppers" />
                                        <p className={`${styles.acheivername} text-center mb-0`}>  GOVADA NAVYA SREE</p>
                                        <p className={`${styles.acheiverrank}  text-center mb-0`}>AIR- 995(2023)</p>
                                        <p className={`${styles.acheivername}  text-center mb-0 `}>Written Score - 254</p>
                                      
                           
                            </div>
                        </div>

                        <div className="col-12 col-md-3 text-center py-xl-2 pt-3">
                        <div className="h-100 pt-3 pb-3" style={{background: '#E8FEFE  0% 0% no-repeat padding-box', opacity: '1'}}>
                                            <span className="d-inline-block pt-5 "><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/sociologytopper2022.pdf" target="_blank" className={`${styles.paybills}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"45px",color:"#DB1B0D"}}></i> <br/>Click here for  <br/>Sociology Toppers  <br/>from 2014 - 2022</a></span>
                        </div>
                        </div>



                        

                        <div className="row">
                 
            </div>  


            </div>
                
        </div>
    
        </>
    )
}
export default UPSC_Main_Test_Series_2023;
